import { createApiSlice } from "@common";
import { CRUD_LMS_ELIGIBILITY_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addLeaveEligibility",
    method: "post",
    url: CRUD_LMS_ELIGIBILITY_CONFIG,
    stateKey: "message",
  },
  {
    name: "getLeaveEligibility",
    method: "get",
    url: CRUD_LMS_ELIGIBILITY_CONFIG,
    stateKey: "data",
  },
  {
    name: "getLeaveEligibilityById",
    method: "get",
    url: CRUD_LMS_ELIGIBILITY_CONFIG,
    stateKey: "data",
  },
  {
    name: "updateLeaveEligibility",
    method: "put",
    url: CRUD_LMS_ELIGIBILITY_CONFIG,
    stateKey: "message",
  },
  {
    name: "deleteLeaveEligibility",
    method: "delete",
    url: CRUD_LMS_ELIGIBILITY_CONFIG,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "productType",
  apiConfig,
  customReducers,
);
const LeaveEligibilitySlice = slice;

export default LeaveEligibilitySlice.reducer;

export const {
  addLeaveEligibility,
  getLeaveEligibility,
  getLeaveEligibilityById,
  updateLeaveEligibility,
  deleteLeaveEligibility,
} = thunks;
export const { rowSelect } = actions;
